var path = 'app/scripts/modules/core/src/pipeline/config/stages/group/groupStage.html';
var html = "<div class=\"form-horizontal\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;